module.exports = __webpack_public_path__ + "img/qr7.ebaf88f8.png";